Vue.component("MpModuleExchanges", {
    props: {
        title: String,
        watermarksUrl: String,
        tooltipValueName: String,
        decimalPoint: String,
        thousandPoint: String,
        tabs: String,
    },
    mixins: [MpCharts],
    data: function() {
        return {
            // Data from PHP IndexController
            SOURCE_VALUES: JSON.parse(VALUES_CHARTS),

            monthTranslations: JSON.parse(monthTranslations),
            shortmonthTranslations: JSON.parse(shortmonthTranslations),
            weekdayTranslations: JSON.parse(weekdayTranslations),
            msDateFormat: JSON.parse(millisecondChartDateFormat),
            sDateFormat: JSON.parse(secondChartDateFormat),
            mDateFormat: JSON.parse(minuteChartDateFormat),
            hDateFormat: JSON.parse(hourChartDateFormat),
            dayDateFormat: JSON.parse(dayChartDateFormat),
            weekDateFormat: JSON.parse(weekChartDateFormat),
            monthDateFormat: JSON.parse(monthChartDateFormat),
            yearDateFormat: JSON.parse(yearChartDateFormat),

            tabList: [],
            currentTab: 0,
        };
    },
    computed: {},
    methods: {

        showTab: function(tabIndex) {
            if (tabIndex === this.currentTab) {
                return;
            }

            this.currentTab = tabIndex;
            this.updateChartData(this.SOURCE_VALUES[this.currentTab], true);
        },

        init: function() {
            this.tabList = JSON.parse(this.tabs);

            this.chart = new Chart(this.$refs.chart, {
                type: 'line',
                data: {
                    datasets: []
                },
                options: this.chartOptions
            });

            this.updateChartData(this.SOURCE_VALUES[this.currentTab], true);
        }
    },

    mounted: function() {
        this.init();
    },

    updated: function() {},

    template: '\
    <section class="tabs promo promo--fullwidth">\
        <h2 class="text-size-s">{{title}}</h2>\
        <div class="tabs__list-wrapper">\
            <ul class="tabs__list">\
                <li class="tabs__item" v-for="tab, index in tabList">\
                    <a href="" class="tabs__link" :class="{\'tabs__link--selected\': currentTab == index}" @click.prevent="showTab(index)">{{tab.currency}}</a>\
                </li>\
            </ul>\
        </div>\
\
        <div class="tabs__content">\
            <canvas id="chart" ref="chart" width="300" height="240"></canvas>\
        </div>\
    </section>',
});
